import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';
import SaveStepButton from './SaveStepButton';
import Whatsapp from './WhatsappButton.js';
import axios from 'axios';
import LoadField from '../components/LoadField';
import { formatMoney } from '../utils/utils.js';

class AmountForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
        this.state = { available_amount: 0}
    }


    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/param?param=available_amount`, config).then((response)=> {
            this.setState({
                available_amount: response.data.available_amount,
              });
        });
    }


    render() {

        const { handleSubmit, submitting, error } = this.props;
        const { available_amount } = this.state;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_amount" description="Amount Form"/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveAmount)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className={error ? "form-group has-error" : "form-group"}>
                                        <div className="help-block text-center">
                                            <Field className="form-control" name="requested_amount" prefix={'$'} autoComplete="off" component={RenderField} type="currency" label="Ingresá el monto" placeholder='Ingresá el monto'/>
                                                {((error && (['ftyc'].includes(process.env.PAGE) ? <span>Has ingresado un monto que supera el límite aceptado para iniciar una Solicitud Online. Podes consultar los montos vigentes en <a href="https://www.ftyc.gob.ar/" target="_blank" rel="noopener noreferrer">ftyc.gob.ar</a></span> : <span>Valor no valido</span>)))}
                                            {available_amount > 0 && (
                                                <div className="available-amount-message text-center" style={{ marginTop: '10px', color: '#666' }}>
                                                    Tenés disponibles {formatMoney(available_amount, 2, ',', '.')} pesos
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {['fiduciaria'].includes(process.env.PAGE) && (<FormattedHTMLMessage id="app.step_amount_info" description="Amount Info"/>)}
                                    {['ftyc'].includes(process.env.PAGE) && (
                                        (available_amount && error) ? (<div><p>{'Puede ingresar un monto inferior hasta ' + `${formatMoney(available_amount, 2, ',', '.')} pesos`}</p></div>) : null
                                    )}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

AmountForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'requested_amount', required: true}]);

AmountForm = TopScrolleable(AmountForm);

AmountForm = reduxForm({
    form: 'AmountForm', // a unique name for this form
    validate
})(AmountForm);

AmountForm = withAuthControl(AmountForm);

export default AmountForm;


/** WEBPACK FOOTER **
 ** ./src/components/AmountForm.js
 **/